export default {
  selection: {
    title: 'Select download format',
  },
  songs: {
    limit: {
      title: 'Download limit reached.',
      descriptionFree:
        'Come back tomorrow to download more, or upgrade now to get full access to Loudly!',
      descriptionPersonal:
        "You've reached your 30-day limit for downloads. Enhance your experience by upgrading now to unlock additional downloads.",
      descriptionPro:
        'You have reached your 30-day limit. Come back in {{daysToReset}} days to download more songs.',
    },
  },
  stems: {
    limit: {
      title: 'Download limit reached.',
      descriptionPersonal:
        "You've reached your 30-day limit for downloads. Enhance your experience by upgrading now to unlock additional downloads.",
      descriptionPro:
        'You have reached your 30-day limit. Come back in {{daysToReset}} days to download more stem packs.',
    },
    rendering: {
      title: 'Stem rendering in progress',
      description1:
        'Once the individual stems are rendered, we will send you a <strong>download link via email</strong>.',
      description2:
        'Additionally, you will find the stems available for download in your library.',
    },
  },
  samplePack: {
    limit: {
      title: 'Download limit reached.',
      descriptionPersonal:
        "You've reached your 30-day limit for downloads. Enhance your experience by upgrading now to unlock additional downloads.",
      descriptionPro:
        'You have reached your 30-day limit. Come back in {{daysToReset}} days to download more sample packs.',
    },
    rendering: {
      title: 'Sample pack rendering in progress',
      description1:
        'Once the sample pack is rendered, we will send you a <strong>download link via email</strong>.',
      description2:
        'Additionally, you will find the sample pack available for download in your library.',
    },
  },
  action: {
    download: 'Download',
    upgrade: 'Upgrade',
    confirm: 'Ok, got it',
    cancel: 'Maybe later',
  },
};
